(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["choose-pot"] && !Shopify.designMode) return;
  try {
    (function () {

  /* ── Money formatter ──────────────────────────────────────── */
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (_) {
      return currency + ' ' + (cents / 100).toFixed(0);
    }
  }

  /* ── Find the <product-price> root for a given product id ──────────── */
  function findProductPriceRoot(productId) {
    return document.querySelector('product-price[data-product-id="' + productId + '"]')
      || document.querySelector('product-price');
  }

  /* ── Locate the real product <form> ─────────────────────── */
  function findProductForm(section, formId) {
    var form = null;
    if (formId) form = document.getElementById(formId);
    if (!form) {
      var pfc = section.querySelector('product-form-component');
      if (pfc) form = pfc.querySelector('form');
    }
    if (!form) {
      form = section.querySelector('form[action*="/cart/add"]');
    }
    return form;
  }

  /* ── Main init ────────────────────────────────────────────── */
  function initChoosePots() {
    document.querySelectorAll('[data-choose-pot]:not([data-pot-init])').forEach(function (root) {
      root.setAttribute('data-pot-init', '');

      var productId = root.dataset.productId;
      var formId    = root.dataset.formId;
      var section   = root.closest('.shopify-section') || document;
      var track     = root.querySelector('[data-pot-track]');
      var cards     = Array.from(root.querySelectorAll('[data-pot-card]'));
      var prevBtn   = root.querySelector('[data-pot-prev]');
      var nextBtn   = root.querySelector('[data-pot-next]');
      var thumb     = root.querySelector('[data-pot-progress]');
      var form      = findProductForm(section, formId);

      if (!form) {
        console.warn('[choose-pot] Could not find product <form> — pot add-to-cart disabled.');
      }

      /* ── Selection state ──────────────────────────────────── */
      // { variantId: string, priceCents: number, title: string, productId: string|null }
      var selection = root._potSelection || { variantId: '', priceCents: 0, title: '', productId: null };
      root._potSelection = selection;

      /* ── Update the visible price display ─────────────────── */
      function updatePriceDisplay(potCents) {
        var priceRoot = findProductPriceRoot(productId);
        if (!priceRoot) return;

        var label = section.querySelector('[data-pot-addon-label]');
        if (!label) {
          label = document.createElement('div');
          label.setAttribute('data-pot-addon-label', '');
          label.style.cssText = [
            'font-size:0.8125rem',
            'color:' + (getComputedStyle(root).getPropertyValue('--pot-accent') || '#1F5746'),
            'margin-top:4px',
            'display:none'
          ].join(';');
          priceRoot.appendChild(label);
        }
        if (potCents > 0) {
          label.textContent = '+ ' + formatMoney(potCents) + ' (pot add-on)';
          label.style.display = 'block';
        } else {
          label.style.display = 'none';
        }
      }

      /* ── Update the price addon shown on a card ────────────── */
      function updateCardAddonDisplay(card, priceCents, compareCents) {
        var addonEl   = card.querySelector('[data-pot-addon-price]');
        var compareEl = card.querySelector('[data-pot-addon-compare]');
        var hasDiscount = compareCents > priceCents;

        if (addonEl) {
          addonEl.textContent = '+ ' + formatMoney(priceCents);
          addonEl.classList.toggle('is-discounted', hasDiscount);
        }
        if (hasDiscount) {
          if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'choose-pot__compare-price';
            compareEl.setAttribute('data-pot-addon-compare', '');
            if (addonEl) addonEl.insertAdjacentElement('afterend', compareEl);
          }
          compareEl.textContent = '+ ' + formatMoney(compareCents);
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }
      }

      /* ── Apply selection from a card (using card's current data-*) ── */
      function applySelectionFromCard(card) {
        var potCents  = parseInt(card.dataset.priceCents || '0', 10);
        var variantId = card.dataset.variantId || '';
        var title     = card.dataset.productTitle || '';
        var cardProductId = card.dataset.productId || null;

        selection.variantId  = variantId;
        selection.priceCents = potCents;
        selection.title      = title;
        selection.productId  = cardProductId;

        updatePriceDisplay(potCents);
      }

      /* ── Select a pot card ────────────────────────────────── */
      function selectCard(card) {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');

        applySelectionFromCard(card);

        root.dispatchEvent(new CustomEvent('pot:selected', {
          bubbles: true,
          detail: {
            priceCents: selection.priceCents,
            variantId: selection.variantId,
            title: selection.title
          }
        }));
      }

      // Attach click handlers for card selection
      cards.forEach(function (card) {
        var btn = card.querySelector('[data-pot-select]');
        if (btn) btn.addEventListener('click', function () { selectCard(card); });
      });

      /* ── Variant pill handlers (per pot, optional) ─────────── */
      cards.forEach(function (card) {
        var picker = card.querySelector('[data-pot-variant-picker]');
        if (!picker) return;

        picker.querySelectorAll('[data-pot-variant-option]').forEach(function (pill) {
          pill.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (pill.disabled) return;

            // Update active pill state
            picker.querySelectorAll('[data-pot-variant-option]').forEach(function (p) {
              p.classList.remove('is-active');
            });
            pill.classList.add('is-active');

            var newVariantId = pill.dataset.variantId;
            var newPriceCents = parseInt(pill.dataset.priceCents || '0', 10);
            var newCompareCents = parseInt(pill.dataset.compareCents || '0', 10);

            // Update card dataset so future selectCard()/applySelectionFromCard() picks it up
            card.dataset.variantId = newVariantId;
            card.dataset.priceCents = newPriceCents;
            card.dataset.compareCents = newCompareCents;

            // Update the displayed addon price on the card
            updateCardAddonDisplay(card, newPriceCents, newCompareCents);

            // If this card is currently the active selection, refresh totals + selection state
            selectCard(card);
          });
        });
      });

      /* ── Combined add-to-cart (main product + pot) ─────────── */
      function getSectionIdsForRender() {
        var ids = [];
        document.querySelectorAll('cart-items-component').forEach(function (item) {
          if (item.dataset && item.dataset.sectionId) ids.push(item.dataset.sectionId);
        });
        return ids;
      }

      function handleFormSubmit(event) {
        // Only intercept when a real pot (with a variant + price) is selected
        if (!selection.variantId || selection.priceCents <= 0) {
          return; // let the normal single-item submit proceed
        }
        if (!form) return;

        // Guard against duplicate/overlapping submissions (e.g. rapid
        // double-click, or this handler being attached more than once
        // to the same <form> across re-inits).
        if (form._potSubmitInFlight) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        form._potSubmitInFlight = true;

        event.preventDefault();
        event.stopImmediatePropagation();

        var formData = new FormData(form);
        var mainVariantId = formData.get('id');
        var quantity = parseInt(formData.get('quantity') || '1', 10) || 1;

        if (!mainVariantId) {
          form._potSubmitInFlight = false;
          return;
        }

        var mainProductTitle = (root.dataset.productTitle && root.dataset.productTitle.trim()) || 'this product';

        var items = [
          {
            id: Number(mainVariantId),
            quantity: quantity
          },
          {
            id: Number(selection.variantId),
            quantity: 1,
            properties: {
              'Selected for': mainProductTitle
            }
          }
        ];

        var sectionIds = getSectionIdsForRender();

        var addToCartBtns = form.querySelectorAll('add-to-cart-component');
        addToCartBtns.forEach(function (c) {
          if (c.disable) c.disable();
        });

        fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: sectionIds.join(',')
          })
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) {
              console.error('[choose-pot] Combined add to cart failed:', response);
              // Surface the error the same way ProductFormComponent does
              var errEl = form.querySelector('[id*="error"]') || section.querySelector('.product-form__error-message-wrapper');
              if (errEl) {
                errEl.classList.remove('hidden');
                errEl.textContent = response.message || response.description || 'Could not add to cart';
              }
              return;
            }

            // Notify the rest of the theme (cart drawer, header count, etc.)
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: response, sourceId: form.id, data: { source: 'choose-pot' } }
            }));
            document.dispatchEvent(new CustomEvent('cart:add', {
              bubbles: true,
              detail: {
                resource: response,
                sourceId: form.id,
                data: {
                  source: 'choose-pot',
                  itemCount: quantity + 1,
                  sections: response.sections
                }
              }
            }));

            // Refresh cart via /cart.js based fetch + dispatch theme's own events if available
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { resource: cart, sourceId: form.id, data: { source: 'choose-pot' } }
                }));
              })
              .catch(function () {});
          })
          .catch(function (err) {
            console.error('[choose-pot] Add to cart error:', err);
          })
          .finally(function () {
            form._potSubmitInFlight = false;
            addToCartBtns.forEach(function (c) {
              if (c.enable) c.enable();
              if (c.animateAddToCart) c.animateAddToCart();
            });
          });
      }

      if (form && !form.dataset.potSubmitBound) {
        form.dataset.potSubmitBound = 'true';
        // Capture phase so we run BEFORE ProductFormComponent's handler
        form.addEventListener('submit', handleFormSubmit, true);
      }

      section.addEventListener('theme:variant:update', function () {
        var selected = root.querySelector('[data-pot-card].is-selected');
        if (selected) {
          setTimeout(function () { applySelectionFromCard(selected); }, 50);
        }
      });

      // Initialize default ("No Pot") selection on load
      var defaultCard = root.querySelector('[data-pot-card].is-selected');
      if (defaultCard) {
        requestAnimationFrame(function () {
          applySelectionFromCard(defaultCard);
        });
      }

      /* ── Slider progress ──────────────────────────────────── */
      function updateProgress() {
        if (!track || !thumb) return;
        var sl  = track.scrollLeft;
        var max = track.scrollWidth - track.clientWidth;

        var thumbW   = max > 0 ? (track.clientWidth / track.scrollWidth) * 100 : 100;
        var thumbOff = max > 0 ? (sl / track.scrollWidth) * 100 : 0;

        thumb.style.width = Math.min(100, thumbW) + '%';
        thumb.style.left  = thumbOff + '%';

        if (prevBtn) prevBtn.disabled = sl <= 1;
        if (nextBtn) nextBtn.disabled = sl >= max - 1;
      }

      function scrollTrack(dir) {
        var w = (cards[0] ? cards[0].offsetWidth : 180) + 14;
        track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollTrack(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollTrack(1); });
      if (track)   track.addEventListener('scroll', updateProgress, { passive: true });

      requestAnimationFrame(updateProgress);
    });
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChoosePots);
  } else {
    initChoosePots();
  }

  // Re-init after Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-choose-pot]').forEach(function (el) {
      el.removeAttribute('data-pot-init');
    });
    initChoosePots();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fake-viewer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.fake-viewer-block__counter').forEach(function (el) {
      const min = parseInt(el.dataset.min, 10);
      const max = parseInt(el.dataset.max, 10);
      const duration = parseInt(el.dataset.duration, 10);

      if (isNaN(min) || isNaN(max) || min > max) return;

      function update() {
        el.textContent = Math.floor(Math.random() * (max - min + 1) + min);
      }

      update();

      if (!isNaN(duration) && duration > 0) {
        setInterval(update, duration);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inventory-status"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.inventory-status-block').forEach(function (el) {
      const min          = parseInt(el.dataset.stockMin, 10);
      const max          = parseInt(el.dataset.stockMax, 10);
      const total        = parseInt(el.dataset.originalStock, 10);
      const countEl      = el.querySelector('.inventory-status-block__count');
      const fillEl       = el.querySelector('.inventory-status-block__bar-fill');
      const progressEl   = el.querySelector('.inventory-status-block__bar-track');

      if (isNaN(min) || isNaN(max) || min > max) return;

      const stock = Math.floor(Math.random() * (max - min + 1) + min);

      // Text
      if (countEl) countEl.textContent = stock;

      // Progress bar
      if (fillEl && !isNaN(total) && total > 0) {
        const pct = Math.min((stock / total) * 100, 100);
        progressEl.setAttribute('aria-valuenow', stock);
        // Delay so CSS transition fires after paint
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fillEl.style.width = pct + '%';
          });
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCountdown(el) {
    var endDate = new Date(el.dataset.endDate).getTime();

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = Date.now();
      var diff = endDate - now;

      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }

      var days    = Math.floor(diff / 86400000);
      var hours   = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      el.querySelector('[data-countdown="days"]').textContent    = pad(days);
      el.querySelector('[data-countdown="hours"]').textContent   = pad(hours);
      el.querySelector('[data-countdown="minutes"]').textContent = pad(minutes);
      el.querySelector('[data-countdown="seconds"]').textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('.product-countdown[data-end-date]').forEach(initCountdown);
})();
  } catch(e) { console.error(e); }
})();

})();
